import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { wipeNewClientState } from 'redux/modules/newClient';
import { showStripeError } from 'redux/modules/billing';
import NewClientFormStep1 from './NewClientFormStep1';
import NewClientFormStep2 from './NewClientFormStep2';
import NewClientStep3 from './NewClientStep3';
import NewClientSummary from './NewClientSummary';
import { Spinner } from 'components';
import * as styles from './NewClient.scss';
var NewClient = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    formValues: state.newClient,
    settingAdsPaymentMethod: state.billing.settingAdsPaymentMethod
  };
}, {
  showStripeError: showStripeError,
  wipeNewClientState: wipeNewClientState
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewClient, _Component);

  var _super = _createSuper(NewClient);

  function NewClient() {
    _classCallCheck(this, NewClient);

    return _super.apply(this, arguments);
  }

  _createClass(NewClient, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.wipeNewClientState();
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          contractInfo = _this$props.contractInfo,
          formValues = _this$props.formValues,
          formStep = _this$props.formStep,
          totals = _this$props.totals;
      return /*#__PURE__*/React.createElement("div", null, contractInfo ? /*#__PURE__*/React.createElement("div", null, formStep === 1 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement(NewClientFormStep1, {
        contractInfo: contractInfo
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement(NewClientSummary, {
        contractInfo: contractInfo,
        orgConfig: formValues.orgConfig,
        totals: totals
      }))), formStep === 2 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement(NewClientFormStep2, {
        contractInfo: contractInfo,
        totals: totals
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement(NewClientSummary, {
        contractInfo: contractInfo,
        orgConfig: formValues.orgConfig,
        totals: totals
      }))), formStep === 3 && /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, this.props.formValues.orgConfig.billingMethod !== 'existing_license' && /*#__PURE__*/React.createElement(NewClientSummary, {
        contractInfo: contractInfo,
        style: {
          marginTop: 24
        },
        orgConfig: formValues.orgConfig,
        totals: totals
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.colWrap
      }, /*#__PURE__*/React.createElement(NewClientStep3, {
        totals: totals,
        contractInfo: contractInfo
      })))) : /*#__PURE__*/React.createElement("div", {
        style: {
          height: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return NewClient;
}(Component)) || _class);
export { NewClient as default };